export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.svg?ab47faeab8ddc5f809ec2a5377c1fbe4";